export class TipoTarea {

    public tipo: string;
    public descripcion: string;
  
}